export default __webpack_public_path__ + "384c5c2214617ba23a2f153a9e8e132e.jpg";